<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mi tarjeta Mastercard</b-card-header>
      <b-card-body>

        <div class="text-center" style="margin-top:10px;margin-bottom:30px;">
            <img src="@/assets/entrega.png" class="mx-auto d-block" width="10%" height="10%" />
        </div>

        <div class="row form-group">
            <div class="col-md-12 text-center">
                <label>Perfecto ¿Dónde la entregamos?</label> 
            </div>
        </div>   

        <div class="row form-group">
          <div class="col-md-12">
            <label>Calle</label>
            <base-input v-model="model.Street" placeholder="Escribí la calle" :maxLength="model.StreetMaxLength"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Número</label>
            <base-input v-model="model.StreetNumber" placeholder="Escribí el número de dirección" :maxLength="model.StreetNumberMaxLength"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Piso</label>
            <base-input v-model="model.Floor" placeholder="Escribí el piso" :maxLength="model.Floor"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Departamento</label>
            <base-input v-model="model.Department" placeholder="Escribí el departamento" :maxLength="model.DepartmentMaxLength"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Barrio</label>
            <base-input v-model="model.Neighborhood" placeholder="Escribí el barrio" :maxLength="model.NeighborhoodMaxLength"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Provincia</label>
            <KitsCombo
              v-model="ProvinceID"
              v-bind:items="Provinces"
              propertyName="Name"
              propertyID="EntityID"
              nullText='Seleccionar'
              :todos="true"
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Localidad</label>
            <KitsBusquedaSimple
              url="City/GetTopByText"
              v-model="Localidad"
              v-on:input="citySelected"
              :currentValue="Localidad"
              :request="searchCityRequest"
            />
          </div>
        </div>

         <div class="row form-group">
          <div class="col-md-12">
            <label>Código Postal</label>
            <base-input v-model="model.PostalCode" :placeholder="postalCodePlaceHolder" :maxLength="model.PostalCodeMaxLength" :disabled="postalCodeDisabled"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12 text-center">
            <save-button @click="validarDomicilio" text="Continuar"></save-button>
          </div>
        </div>

      </b-card-body>
    </b-card>

    <modal :show.sync="showConfirmAddressModal" size="lg">
      <template slot="header">
        <h5 class="modal-title">Confirmación de domicilio</h5>
      </template>
      <div>
        <h3 class="text-center" style="color:#ff5855">¡Verificá la Dirección!</h3>
        <p class="text-center">Por favor revisá los datos</p>
        <hr />
        <div>
          <div class="row form-group" style="margin-bottom:3px;">
            <label class="col-4 col-form-label text-right" style="padding-top:4px;">Calle</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" v-model="model.Street" readonly />
            </div>
          </div>
          <div class="row form-group" style="margin-bottom:3px;">
            <label class="col-4 col-form-label text-right" style="padding-top:4px;">Numero</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" v-model="model.StreetNumber" readonly />
            </div>
          </div>
          <div class="row form-group" style="margin-bottom:3px;">
            <label class="col-4 col-form-label text-right" style="padding-top:4px;">Piso</label>
            <div class="col-3">
              <input type="text" class="form-control form-control-sm" v-model="model.Floor" readonly />
            </div>
            <label class="col-2 col-form-label text-right" style="padding-top:4px;">Depto.</label>
            <div class="col-3">
              <input type="text" class="form-control form-control-sm" v-model="model.Department" readonly />
            </div>
          </div>
          <div class="row form-group" style="margin-bottom:3px;">
            <label class="col-4 col-form-label text-right" style="padding-top:4px;">Provincia</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" v-model="selectedProvinceName" readonly />
            </div>
          </div>
          <div class="row form-group" style="margin-bottom:3px;">
            <label class="col-4 col-form-label text-right" style="padding-top:4px;">Localidad</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" v-model="cityText" readonly />
            </div>
          </div>
          <div class="row form-group" style="margin-bottom:3px;">
            <label class="col-4 col-form-label text-right" style="padding-top:4px;">Código Postal</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" v-model="model.PostalCode" readonly />
            </div>
          </div>
          <div class="row form-group" style="margin-bottom:3px;">
            <label class="col-4 col-form-label text-right" style="padding-top:4px;">Barrio</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" v-model="model.Neighborhood" readonly />
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click="continuar">Confirmar</base-button>
        <base-button type="secondary" @click="showConfirmAddressModal=false">Cancelar</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
  import Vue from "vue";
  import vSelect from "vue-select";
  Vue.component("v-select", vSelect);
  import "vue-select/dist/vue-select.css";
  import axiosHelpers from "@/helpers/axiosHelpers";
  import notificationHelpers from "@/helpers/notificationHelpers";
  import KitsCombo from "@/components/KitsCombo";
  import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";

  export default {
    components: { KitsCombo, KitsBusquedaSimple },
    data() {
      return {
        model: {
          AccountID: 0,
          CityID: null,
          CityName: "",
          Street: "",
          StreetNumber: "",
          Floor: "",
          Department: "",
          PostalCode: "",
          AddressType: 0,
          Neighborhood: "",
          NeighborhoodMaxLength: 0,
          StreetMaxLength: 0,
          StreetNumberMaxLength: 0,
          FloorMaxLength: 0,
          DepartmentMaxLength: 0,
          PostalCodeMaxLength: 0
        },
        Localidad: null,
        Provinces: [],
        ProvinceID: null,
        showConfirmAddressModal: false
      };
    },
    methods: {
      citySelected (city) {
        if (this.postalCodeDisabled) {
          this.model.PostalCode = city.CodigoPostal;
        }
      },
      validarDomicilio() {
        let context = this;

        // -- Calle
        if (context.model.Street == "") 
        {
              notificationHelpers.showWarning("Advertencia!", "Debe ingresar una calle.", context);
              return;
        }
        // -- Numero de la calle
        else if (context.model.StreetNumber == "") 
        {
              notificationHelpers.showWarning("Advertencia!", "Debe ingresar un número de calle.", context);
              return;
        }
        // -- Provincia
        else if (context.ProvinceID == null || isNaN(context.ProvinceID)) 
        {
            notificationHelpers.showWarning("Advertencia!", "Debe seleccionar una provincia.", context);
            return;
        }
        // -- Localidad
        else if (context.Localidad == null) 
        {
              notificationHelpers.showWarning("Advertencia!", "Debe seleccionar una localidad.", context);
              return;
        }
        // -- Codigo Postal
        else if (context.model.PostalCode == "") 
        {
              notificationHelpers.showWarning("Advertencia!", "Debe seleccionar un código postal.", context);
              return;
        }
        // -- Barrio
        else if (context.model.Neighborhood == "") 
        {
              notificationHelpers.showWarning("Advertencia!", "Debe ingresar un barrio.", context);
              return;
        }

        this.$validator.validate().then(valid => {
          if (valid) {
            axiosHelpers.axiosPost(
              "Account/ValidateZipCodeAndAddress",
              {
                ProvinceID: context.ProvinceID,
                ZipCode: context.model.PostalCode,
                VerifyAddressRequest: {
                  Province: this.selectedProvince.Name,
                  City: context.Localidad.Text,
                  PostalCode: context.model.PostalCode,
                  Street: context.model.Street,
                  StreetNumber: context.model.StreetNumber
                }
              },
              this,
              function(data) {
                if (data.ResponseVM.SuccessVerification == true && data.ResponseVM.ResponseMessage == null) {
                  context.model.Street = data.ResponseVM.NormalizedAddress
                  context.showConfirmAddressModal = true;
                } else if (data.ResponseVM.ResponseMessage != null) {
                  notificationHelpers.showWarning(
                    "Error",
                    data.ResponseVM.ResponseMessage,
                    context
                  );
                }
              }
            );
          } else {
            notificationHelpers.showWarning(
              "Advertencia!",
              "Verifique todos los campos",
              context
            );
          }
        });
      },
      continuar () {
        let context = this;
        axiosHelpers.axiosPost(
          "Account/SaveAccountAddress",
          {
            CityID: context.Localidad != null ? context.Localidad.ID : 0,
            Street: context.model.Street,
            Number: context.model.StreetNumber,
            Floor: context.model.Floor,
            Department: context.model.Department,
            PostalCode: context.model.PostalCode,
            AccountID: context.$store.getters.accountID,
            AddressType: context.$store.getters.TipoDireccionEntrega,
            Neighborhood: context.model.Neighborhood
          },
          this,
          function(data) {
            if (data.ResponseVM.Result) {
              context.showConfirmAddressModal = false;
              context.$router.push("FinishCardGeneration");
            }
          });
      },
      getData() {
        let context = this;  
          axiosHelpers.axiosPost(
            "Account/GetAccountAddress",
            { 
              AccountID: context.$store.getters.accountID,
              AddressType: context.$store.getters.TipoDireccionEntrega
            },
            this,
            function(data) {
              context.model.Street = data.ResponseVM.Street;
              context.model.StreetNumber = data.ResponseVM.StreetNumber;
              context.model.Floor = data.ResponseVM.Floor;
              context.model.Department = data.ResponseVM.Departament;
              context.model.PostalCode = data.ResponseVM.PostalCode;
              context.Localidad = {
                ID: data.ResponseVM.CityID,
                Text: data.ResponseVM.CityName
              };
              context.model.Neighborhood = data.ResponseVM.Neighborhood;
              context.Provinces = data.ResponseVM.Provinces;

              context.$nextTick(() => {
                context.ProvinceID = data.ResponseVM.ProvinceID;
              });
            }
          );
      }, 
    },
    mounted() {
      let context = this;

      // -- Inicializamos los Length de los entries en base a los parametros
      context.model.NeighborhoodMaxLength = context.$store.getters.MAX_LENGTH_NEIGHBORHOOD;
      context.model.StreetMaxLength = context.$store.getters.MAX_LENGTH_STREET;
      context.model.StreetNumberMaxLength = context.$store.getters.MAX_LENGTH_STREET_NUMBER;
      context.model.FloorMaxLength = context.$store.getters.MAX_LENGTH_FLOOR;
      context.model.DepartmentMaxLength = context.$store.getters.MAX_LENGTH_DEPARTMENT;
      context.model.PostalCodeMaxLength = context.$store.getters.MAX_LENGTH_POSTAL_CODE;

      context.getData();
    },
    computed: {
      postalCodeDisabled() {
        if (this.selectedProvince == null) {
          return false;
        }

        return !this.selectedProvince.IsPostalCodeEnable;
      },
      postalCodePlaceHolder () {
        const DEFAULT_PLACEHOLDER = 'Código postal';
        
        if (this.selectedProvince == null) {
          return DEFAULT_PLACEHOLDER;
        }

        return this.selectedProvince.PostalCodePlaceHolder;
      },
      cityText () {
        return this.Localidad != null ? this.Localidad.Text : '';
      },
      selectedProvinceName () {
        return this.selectedProvince != null ? this.selectedProvince.Name : '';
      },
      selectedProvince () {
        let context = this;

        if (isNaN(context.ProvinceID)) {
          return null;
        }

        let provinces = context.Provinces.filter(p => p.EntityID == context.ProvinceID);
        let province = provinces[0];

        if (province == undefined) {
          return null;
        }

        return province;
      },
      searchCityRequest () {
        return { provinceID: this.ProvinceID };
      }
    },
    watch: {
      ProvinceID (newValue, oldValue) {
        if (oldValue != undefined && oldValue != null && newValue != oldValue) {
          this.Localidad = null;
          this.model.PostalCode = '';
        }
      }
    }
  };
</script>